/*
  Lunare PDP sections – shared behaviour.
  Loaded (deferred) by every Lunare section that needs JS; the guard makes it run once.
  Cross-section wiring goes through document events:
    aa-lunare:variant  { variant }  – main product variant changed (sticky bar, S7, S11 listen)
    aa-lunare:pick-qty qty          – S7 / S11 buttons ask the main product to select a bundle
*/
(function () {
  if (window.AALunare) return;
  window.AALunare = true;

  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function stripTags(t) { return String(t).replace(/<[^>]*>/g, ''); }

  function makeFmt(format) {
    return function (cents) {
      cents = Math.round(cents);
      if (!format) return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
      var f = format;
      function delim(n, p, th, dec) {
        var parts = (n / 100).toFixed(p).split('.');
        return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
      }
      var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount', val;
      switch (key) {
        case 'amount_no_decimals': val = delim(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': val = delim(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': val = delim(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': val = delim(cents, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
        default: val = delim(cents, 2, ',', '.');
      }
      return f.replace(/\{\{\s*\w+\s*\}\}/, val);
    };
  }

  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
  function bundleTotal(price, q, disc) { return Math.floor(price * q * (100 - disc) / 100); }
  function bundleHTML(fmt, v, q, disc) {
    var unitCmp = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
    var total = bundleTotal(v.price, q, disc), cmp = unitCmp * q;
    return '<b>' + fmt(total) + '</b>' + (cmp > total ? '<s>' + fmt(cmp) + '</s>' : '');
  }
  /* Discount of the main product's Bundle tier with this quantity (source of truth), or null */
  function mainDisc(q) {
    var inp = document.querySelector('[data-lnx-main] [data-lnx-bundles] input[value="' + q + '"]');
    return inp ? parseFloat(inp.dataset.disc || 0) : null;
  }
  function mainAtc() { return document.querySelector('[data-lnx-main] [data-lnx-atc]'); }

  /* ---------- Main product (S5) ---------- */
  function initMain(root) {
    var jsonEl = root.querySelector('[data-lnx-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var L = data.labels, fmt = makeFmt(data.moneyFormat);
    var idInput = root.querySelector('[data-lnx-variant-input]');
    var qtyInput = root.querySelector('[data-lnx-qty-input]');

    /* PRICE + COMPARE: compare struck only when compare_at_price > price */
    function priceHTML(v, withBadge) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var save = v.compare_at_price - v.price;
        var pct = Math.round(save * 100 / v.compare_at_price);
        return '<span class="aa-lnx-vh">' + esc(L.sale) + '</span><span class="aa-lnx-price__sale aa-lnx-price__sale--on">' + fmt(v.price) + '</span>' +
          '<span class="aa-lnx-vh">' + esc(L.regular) + '</span><s class="aa-lnx-price__compare">' + fmt(v.compare_at_price) + '</s>' +
          (withBadge ? '<span class="aa-lnx-price__badge">−' + pct + '% · ' + esc(L.save) + ' ' + fmt(save) + '</span>' : '');
      }
      return '<span class="aa-lnx-vh">' + esc(L.regular) + '</span><span class="aa-lnx-price__sale">' + fmt(v.price) + '</span>';
    }
    function eachText(v, q, disc) {
      return String(L.each || '').replace('[PRICE]', fmt(Math.floor(bundleTotal(v.price, q, disc) / q)));
    }

    var fieldsets = root.querySelectorAll('select[data-lnx-option]');
    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (sel) { return sel.value; });
    }
    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (sel, idx) {
        Array.prototype.forEach.call(sel.options, function (o) {
          if (!o.dataset.base) o.dataset.base = o.textContent;
          var test = opts.slice(); test[idx] = o.value;
          var v = findVariant(test);
          o.textContent = o.dataset.base + ((!v || !v.available) ? ' – ' + L.soldout : '');
        });
      });
    }
    function updateBundles(v) {
      root.querySelectorAll('[data-lnx-bundles] input').forEach(function (inp) {
        var b = inp.closest('.aa-lnx-bundle'), q = parseInt(inp.value, 10), disc = parseFloat(inp.dataset.disc || 0);
        var el = b.querySelector('[data-lnx-bundle-price]');
        if (el) el.innerHTML = bundleHTML(fmt, v, q, disc);
        var ch = b.querySelector('[data-lnx-each]');
        if (ch) ch.textContent = eachText(v, q, disc);
      });
    }
    var gal = root.querySelector('[data-lnx-gallery]');
    function goToMedia(id) {
      var slide = gal ? gal.querySelector('[data-media-id="' + id + '"]') : null;
      if (!slide) return;
      if (gal.scrollWidth > gal.clientWidth + 4) { gal.scrollTo({ left: slide.offsetLeft - gal.offsetLeft, behavior: 'smooth' }); }
      else { gal.querySelectorAll('.aa-lnx-gallery__slide').forEach(function (x) { x.classList.toggle('is-lead', x === slide); }); }
    }
    var galI = root.querySelector('[data-lnx-gal-i]');
    if (gal && galI) gal.addEventListener('scroll', function () { galI.textContent = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)) + 1; }, { passive: true });
    var thumb = root.querySelector('[data-lnx-thumb] img');
    function onVariant() {
      var opts = selectedOptions();
      markAvailability(opts);
      var v = findVariant(opts);
      var atcs = root.querySelectorAll('[data-lnx-atc]');
      if (!v) {
        atcs.forEach(function (b) { b.disabled = true; b.querySelector('[data-lnx-atc-text]').textContent = L.unavailable; });
        emit('aa-lunare:variant', { variant: null });
        return;
      }
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-lnx-price]').forEach(function (el) { el.innerHTML = priceHTML(v, true); });
      atcs.forEach(function (b) { b.disabled = !v.available; b.querySelector('[data-lnx-atc-text]').textContent = v.available ? L.atc : L.soldout; });
      updateBundles(v);
      if (thumb && v.featured_image && v.featured_image.src) { thumb.src = v.featured_image.src; thumb.removeAttribute('srcset'); }
      if (v.featured_media && v.featured_media.id) goToMedia(v.featured_media.id);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      var st = root.querySelector('[data-lnx-status]'); if (st) st.textContent = opts.join(' / ') + ' – ' + fmt(v.price);
      emit('aa-lunare:variant', { variant: v });
    }
    fieldsets.forEach(function (sel) { sel.addEventListener('change', onVariant); });
    if (fieldsets.length) markAvailability(selectedOptions());

    /* Bundles → form quantity */
    function setQty(q) {
      if (qtyInput) qtyInput.value = q;
      root.querySelectorAll('[data-lnx-bundles] input').forEach(function (inp) { inp.checked = String(inp.value) === String(q); });
      placeOpts();
    }
    /* Variant selects live inside the selected bundle card */
    var optsEl = root.querySelector('[data-lnx-opts]');
    function placeOpts() {
      var cur = root.querySelector('[data-lnx-bundles] input:checked');
      root.querySelectorAll('.aa-lnx-bundle').forEach(function (b) { b.classList.toggle('is-selected', !!cur && b.contains(cur)); });
      if (!optsEl) return;
      var slot = cur ? cur.closest('.aa-lnx-bundle').querySelector('[data-lnx-opts-slot]') : null;
      (slot || root.querySelector('[data-lnx-opts-home]')).appendChild(optsEl);
    }
    placeOpts();
    root.querySelectorAll('[data-lnx-bundles] input').forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) setQty(inp.value); });
    });
    document.addEventListener('aa-lunare:pick-qty', function (e) {
      var q = String(e.detail);
      if (root.isConnected && root.querySelector('[data-lnx-bundles] input[value="' + q + '"]')) setQty(q);
    });

    /* Ships-by date: browser local time, cutoff hour, business days (Mon–Fri) */
    var ship = root.querySelector('[data-lnx-ship]');
    if (ship) {
      var cutoff = parseInt(ship.dataset.cutoff, 10), days = parseInt(ship.dataset.days, 10) || 0, d = new Date();
      var weekend = function (x) { return x.getDay() === 0 || x.getDay() === 6; };
      if (weekend(d) || d.getHours() >= cutoff) { days += 1; }
      while (days > 0) { d.setDate(d.getDate() + 1); if (!weekend(d)) days--; }
      if (parseInt(ship.dataset.days, 10) === 0 && weekend(d)) { while (weekend(d)) d.setDate(d.getDate() + 1); }
      var txt;
      try { txt = d.toLocaleDateString(ship.dataset.locale || 'pl', { day: 'numeric', month: 'long' }); } catch (e) { txt = d.toDateString(); }
      ship.innerHTML = '<i class="aa-lnx-dot aa-lnx-dot--gold"></i>' + esc(ship.dataset.prefix) + ' <b>' + esc(txt) + '</b>';
    }

    /* Size finder */
    var finder = root.querySelector('[data-lnx-finder]');
    if (finder) {
      var rows = Array.prototype.map.call(root.querySelectorAll('[data-lnx-size-row]'), function (r) {
        return { size: r.dataset.size, wmin: parseFloat(r.dataset.wmin), wmax: parseFloat(r.dataset.wmax), hmin: parseFloat(r.dataset.hmin), hmax: parseFloat(r.dataset.hmax) };
      });
      var kg = finder.querySelector('[data-lnx-kg]'), cm = finder.querySelector('[data-lnx-cm]'), out = finder.querySelector('[data-lnx-finder-out]');
      var pickSize = function (size) {
        fieldsets.forEach(function (sel) { Array.prototype.forEach.call(sel.options, function (o) { if (o.value.toLowerCase() === size.toLowerCase()) sel.value = o.value; }); });
        onVariant();
      };
      var runFinder = function () {
        var w = parseFloat(kg.value), h = parseFloat(cm.value);
        if (!w) { out.innerHTML = ''; return; }
        var valid = rows.filter(function (r) { return !isNaN(r.wmin) && !isNaN(r.wmax); });
        if (!valid.length) { out.textContent = L.finderMissing; return; }
        var hits = valid.filter(function (r) { return w >= r.wmin && w <= r.wmax; });
        if (!hits.length) { out.textContent = L.finderNone; return; }
        var html = hits.length > 1 ? esc(L.finderBetween) + '<br>' : '';
        hits.forEach(function (r) {
          var leg = '';
          if (h && !isNaN(r.hmin) && !isNaN(r.hmax)) leg = h > r.hmax ? L.legShort : (h < r.hmin ? L.legLong : L.legOk);
          html += '<button type="button" data-size="' + esc(r.size) + '">' + esc(String(L.finderPick).replace('[SIZE]', r.size)) + '</button>' + (leg ? ' <small>' + esc(leg) + '</small>' : '');
        });
        out.innerHTML = html;
        out.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { pickSize(b.dataset.size); }); });
      };
      /* The finder sits inside the product form – Enter must not submit (add to cart) */
      var noSubmit = function (e) { if (e.key === 'Enter') { e.preventDefault(); runFinder(); } };
      kg.addEventListener('input', runFinder); cm.addEventListener('input', runFinder);
      kg.addEventListener('keydown', noSubmit); cm.addEventListener('keydown', noSubmit);
      var openSize = finder.querySelector('[data-lnx-open-size]');
      if (openSize) openSize.addEventListener('click', function () { var d2 = root.querySelector('[data-lnx-size-details]'); if (d2) d2.open = true; });
    }
  }

  /* ---------- S7 / S11: buttons that select a bundle in the main product ---------- */
  function initPickQty(root) {
    root.querySelectorAll('[data-lnx-pick-qty]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        emit('aa-lunare:pick-qty', el.getAttribute('data-lnx-pick-qty'));
        var buy = document.getElementById('aa-lnx-buy');
        if (buy) { e.preventDefault(); buy.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }

  /* ---------- S7 / S11: live bundle prices (follow the main product variant) ---------- */
  function initLive(root) {
    var els = root.querySelectorAll('[data-lnx-live]');
    if (!els.length) return;
    var fmt = makeFmt(root.dataset.money);
    function render(el, v) {
      var q = parseInt(el.dataset.qty, 10) || 1;
      var md = mainDisc(q), disc = md === null ? parseFloat(el.dataset.disc || 0) : md;
      if (el.dataset.lnxLive === 'cta') el.textContent = String(el.dataset.tpl || '').replace('[PRICE]', stripTags(fmt(bundleTotal(v.price, q, disc))));
      else el.innerHTML = bundleHTML(fmt, v, q, disc);
    }
    els.forEach(function (el) { render(el, { price: parseInt(el.dataset.price, 10), compare_at_price: parseInt(el.dataset.compare, 10) }); });
    document.addEventListener('aa-lunare:variant', function (e) {
      var v = e.detail && e.detail.variant;
      if (v) els.forEach(function (el) { render(el, v); });
    });
  }

  /* ---------- S4: carousel dots (mobile rails) ---------- */
  function initDots(root) {
    root.querySelectorAll('[data-lnx-rail]').forEach(function (rail) {
      var dots = rail.parentNode.querySelector('[data-lnx-dots]'); if (!dots) return;
      var n = rail.children.length; for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
      var upd = function () { var w = rail.children[0] ? rail.children[0].offsetWidth : 1; var k = Math.round(rail.scrollLeft / Math.max(1, w)); Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-on', j === k); }); };
      rail.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }

  /* ---------- S9: video sound toggle ---------- */
  function initSound(root) {
    var soundBtns = root.querySelectorAll('[data-lnx-sound]');
    soundBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.parentNode.querySelector('video'); if (!v) return;
        root.querySelectorAll('.aa-lnx-video video').forEach(function (o) { if (o !== v) o.muted = true; });
        v.muted = !v.muted; if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        soundBtns.forEach(function (o) { var ov = o.parentNode.querySelector('video'); o.classList.toggle('is-on', !!ov && !ov.muted); });
      });
    });
  }

  /* ---------- S15: sticky add to cart (clicks the main ATC) ---------- */
  function initSticky(root) {
    var sticky = root.querySelector('[data-lnx-sticky]');
    if (!sticky) return;
    var btn = sticky.querySelector('[data-lnx-sticky-btn]');
    var fmt = makeFmt(root.dataset.money);
    if (btn) btn.addEventListener('click', function () { var a = mainAtc(); if (a && !a.disabled) a.click(); });

    document.addEventListener('aa-lunare:variant', function (e) {
      var v = e.detail && e.detail.variant;
      var t = btn ? btn.querySelector('[data-lnx-atc-text]') : null;
      if (!v) { if (btn) btn.disabled = true; if (t) t.textContent = sticky.dataset.unavailable; return; }
      if (btn) btn.disabled = !v.available;
      if (t) t.textContent = v.available ? sticky.dataset.atc : sticky.dataset.soldout;
      var p = sticky.querySelector('[data-lnx-sticky-price]');
      if (p) p.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
        ? '<span class="aa-lnx-price__sale aa-lnx-price__sale--on">' + fmt(v.price) + '</span><s class="aa-lnx-price__compare">' + fmt(v.compare_at_price) + '</s>'
        : '<span class="aa-lnx-price__sale">' + fmt(v.price) + '</span>';
    });

    /* Visible once the main ATC scrolls above the viewport */
    var ticking = false, shown = null;
    var checkSticky = function () {
      ticking = false;
      var a = mainAtc();
      var show = !!a && a.getBoundingClientRect().bottom < 0;
      if (show === shown) return; shown = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(checkSticky); } }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
  }

  function init(root) {
    if (!root || root.dataset.lnxInit) return;
    root.dataset.lnxInit = '1';
    if (root.hasAttribute('data-lnx-main')) initMain(root);
    initPickQty(root);
    initLive(root);
    initDots(root);
    initSound(root);
    initSticky(root);
  }

  function initAll() { document.querySelectorAll('[data-lnx-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-lnx-root]'); if (r) init(r); });
})();
